import React from "react";
import MaterialToolTip from "components/MaterialToolTip";
import { RadioFieldContainer } from "styles/components/RadioButton";

const RadioButton = (props) => {

  return (
    <RadioFieldContainer className={props.className}>
      <label className={"radio-container"} htmlFor={props?.id}>
        <span>
          {props?.label}
        </span>
        <input
          name={props?.field?.name}
          id={props?.id}
          type="radio"
          value={props?.id}
          checked={props?.id === props?.value || props?.id === props?.defaultValue}
          onChange={props?.field?.onChange}
          disabled={props?.disabled}
          onClick={(e) => {
            props?.onSelect(e, props);
          }}
          onBlur={props?.field?.onBlur}
          {...props}
        />
        {!props?.disabled && <span className={"radio-checkmark"}></span>}

        {props?.field?.name === "lotsOption" && <MaterialToolTip title={props?.index === 0 ? "Create individual posts on the marketplace for each lot to sell to multiple buyers." :
          " Create one post for all lots to sell all lots to one buyer."} />}
      </label>
    </RadioFieldContainer>
  );
};

export default RadioButton;
